module.exports = __webpack_public_path__ + "static/barclay-card-491651c53b5180930fadb5d6b17360bd.png";